webpackJsonp([42],{

/***/ "+UpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+z4t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export objToString */
/* harmony export (immutable) */ __webpack_exports__["c"] = checkSMS;
/* harmony export (immutable) */ __webpack_exports__["a"] = checkMobile;
/* harmony export (immutable) */ __webpack_exports__["f"] = isCardNo;
/* harmony export (immutable) */ __webpack_exports__["b"] = checkReservation;
/* unused harmony export urlEncode */
/* unused harmony export getDistanceSortList */
/* unused harmony export getDistance */
/* unused harmony export TMap */
/* unused harmony export getLoacation */
/* harmony export (immutable) */ __webpack_exports__["d"] = delay;
/* harmony export (immutable) */ __webpack_exports__["e"] = formatTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


function objToString(obj) {
  for (var i in obj) {
    console.log(i + '=' + obj[i]);
  }
}

// 短信验证码验证
function checkSMS(nums) {
  var reg = /^\d{6}$/;
  return nums.length !== 6 && !reg.test(nums) ? [false, '请输入6位短信验证码'] : [true, ''];
}
// 手机号码验证
function checkMobile(mobile) {
  var myreg = /^(((13[0-9]{1})|(14[5,7]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
  if (!myreg.test(mobile)) {
    return [false, '请输入有效的手机号码！'];
  } else {
    localStorage.mobile_number = mobile;
    return [true, ''];
  }
}

// 身份证验证
function isCardNo(card) {
  // 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  return reg.test(card) === false ? [false, '请输入正确的身份证号码'] : [true, ''];
}

// 验证预约时间，必须提前一天，并且不能为周末
function checkReservationDate(time) {
  var t = new Date(time);
  var nt = new Date();
  nt.setHours(0);
  nt.setMinutes(0);
  nt.setSeconds(0);
  if (t.getDay() === 6 || t.getDay() === 7) {
    return [false, '周末无法预约，请预约工作日办理'];
  }
  if (parseInt((t - nt) / 1000 / (24 * 3600)) <= 0) {
    return [false, '请提前一天进行预约！'];
  }
  return [true, ''];
}

// 预约验证
function checkReservation(obj) {
  var ver_mob = checkMobile(obj.phone_number);
  var ver_card = isCardNo(obj.id_no);
  var ver_date = obj.booking_time ? checkReservationDate(obj.booking_time) : [false, '预约时间不能为空'];

  if (!ver_date[0]) return ver_date;
  if (obj.booking_type === 2) {
    if (!obj.address) return [false, '家庭地址不能为空！'];
  }
  if (!obj.username) return [false, '申请人姓名不能为空！'];
  if (!ver_card[0]) return ver_card;
  if (!ver_mob[0]) return ver_mob;

  return [true, ''];
}

// 转码
function urlEncode(param, key, encode) {
  if (param == null) return '';
  var paramStr = '';
  var t = typeof param === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(param);
  if (t === 'string' || t === 'number' || t === 'boolean') {
    paramStr += '&' + key + '=' + (encode == null || encode ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);
      paramStr += urlEncode(param[i], k, encode);
    }
  }
  return paramStr;
}

// 距离排序
function getDistanceSortList(arr) {
  return arr.sort(function (a, b) {
    return a.distance - b.distance;
  });
}

// 距离比较
function getDistance(lat1, lng1, lat2, lng2) {
  var radLat1 = lat1 * Math.PI / 180.0;
  var radLat2 = lat2 * Math.PI / 180.0;
  var a = radLat1 - radLat2;
  var b = lng1 * Math.PI / 180.0 - lng2 * Math.PI / 180.0;
  var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
  s = s * 6378.137; // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000;
  return s;
}

// 地图设置
function TMap(key) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    window.init = function () {
      resolve(window.qq); // 注意这里
    };
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://map.qq.com/api/js?v=2.exp&libraries=geometry&callback=init&key=' + key;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// 获取位置
function getLoacation() {
  var geolocation = new this.qq.maps.Geolocation('GPVBZ-MVIW4-BZVUR-XYXSY-ZOZ2V-J2FJT', 'lvpin100');
  var options = {
    timeout: 2000
  };
  geolocation.getLocation(postion, err, options);

  function postion(postion) {
    // next([true, postion]);
    window.userLocation = [true, postion];
  }

  function err() {
    // next([false, "定位失败"]);
    window.userLocation = [false, '定位失败'];
  }
}

// 延时
function delay(time, random) {
  var t = time + Math.floor(Math.random() * random);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
    setTimeout(resolve, t);
  });
}
function formatTime(timestamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd HH:mm';

  var formatNum = function formatNum(num) {
    return String(num).padStart(2, '0');
  };
  var date = new Date(timestamp);
  return format.replace(/yyyy/g, date.getFullYear()).replace(/MM/g, formatNum(date.getMonth() + 1)).replace(/dd/g, formatNum(date.getDate())).replace(/HH/g, formatNum(date.getHours())).replace(/mm/g, formatNum(date.getMinutes())).replace(/ss/g, formatNum(date.getSeconds())).replace(/SSS/g, formatNum(date.getMilliseconds()));
}

/***/ }),

/***/ "1QwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1VXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = listToTree;
/* unused harmony export formatTime */
/* unused harmony export treeToList */
/* unused harmony export IsPC */
/* unused harmony export getLangDate */
/* harmony export (immutable) */ __webpack_exports__["c"] = setAppId;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppId;
/* unused harmony export setAppInfo */
/* unused harmony export getAppInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var APP_INFO = 'appInfo';

function _sortFunc(a, b) {
  return a.sort - b.sort;
}

function listToTree(srcList, destList) {
  var sortFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _sortFunc;

  if (!destList) {
    destList = [];
  } else {
    destList.splice(0, destList.length);
  }
  if (!srcList) return destList;
  var nodeData = {};
  srcList.forEach(function (item) {
    if (item.name) {
      item.label = item.name;
      item.value = item.id;
    }
    item.children = [];
    nodeData[item.id] = item;
  });
  srcList.forEach(function (item) {
    if (item.parentId) {
      var parent = nodeData[item.parentId];
      if (parent) {
        parent.children.push(item);
        parent.children.sort(sortFunc);
        return;
      }
    }
    destList.push(item);
  });
  destList.sort(sortFunc);
  return destList;
}

function formatTime(timestamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd HH:mm';

  var formatNum = function formatNum(num) {
    return String(num).padStart(2, '0');
  };
  var date = new Date(timestamp);
  return format.replace(/yyyy/g, date.getFullYear()).replace(/MM/g, formatNum(date.getMonth() + 1)).replace(/dd/g, formatNum(date.getDate())).replace(/HH/g, formatNum(date.getHours())).replace(/mm/g, formatNum(date.getMinutes())).replace(/ss/g, formatNum(date.getSeconds())).replace(/SSS/g, formatNum(date.getMilliseconds()));
}

function treeToList(tree) {
  var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (tree) {
    tree.forEach(function (element) {
      list.push(element);
      element.level = level;
      element.children && treeToList(element.children, list, level + 1);
      delete element.children;
    });
  }
  return list;
}

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

function getLangDate() {
  var dateObj = new Date(); // 表示当前系统时间的Date对象
  var year = dateObj.getFullYear(); // 当前系统时间的完整年份值
  var month = dateObj.getMonth() + 1; // 当前系统时间的月份值
  var date = dateObj.getDate(); // 当前系统时间的月份中的日
  var day = dateObj.getDay(); // 当前系统时间中的星期值
  var weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  var week = weeks[day]; // 根据星期值，从数组中获取对应的星期字符串
  var hour = dateObj.getHours(); // 当前系统时间的小时值
  var minute = dateObj.getMinutes(); // 当前系统时间的分钟值
  var second = dateObj.getSeconds(); // 当前系统时间的秒钟值
  // 如果月、日、小时、分、秒的值小于10，在前面补0
  if (month < 10) {
    month = '0' + month;
  }
  if (date < 10) {
    date = '0' + date;
  }
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minute < 10) {
    minute = '0' + minute;
  }
  if (second < 10) {
    second = '0' + second;
  }
  var newDate = [hour + ':' + minute, year + '/' + month + '/' + date + '&nbsp;&nbsp;' + week];

  return newDate;
}

function setAppId(appId) {
  localStorage.setItem('appId', appId);
}

function getAppId() {
  return localStorage.getItem('appId');
}

function setAppInfo(appInfo) {
  localStorage.setItem(APP_INFO, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(appInfo));
}

function getAppInfo() {
  return localStorage.getItem(APP_INFO);
}

/***/ }),

/***/ "4kIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directive__ = __webpack_require__("nCtB");


/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _opts$directiveName = opts.directiveName,
        directiveName = _opts$directiveName === undefined ? 'directory' : _opts$directiveName;

    Vue.directive(directiveName, __WEBPACK_IMPORTED_MODULE_0__directive__["a" /* default */]);
  }
});

/***/ }),

/***/ "6+u4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_URL; });
var domains = {
  production: {
    domain: 'https://hrpay.laway.cn',
    name: '外网正式服'
  },
  dev: {
    domain: 'https://hrpay.laway.cn',
    name: '内网开发服'
  }
};
var isDev = "production" !== 'production';
var server = 'production';
if (isDev) {
  server = localStorage.getItem('server');
  if (!server || !domains[server]) {
    server = 'dev';
  }
  localStorage.setItem('server', server);
}
var url = domains[server].domain + '/api/speed-front';
var BASE_URL = url;

/***/ }),

/***/ "FW8Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FyIo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"loading-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.ismask),expression:"!ismask"}],staticClass:"loading-mask"}),_vm._v(" "),_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"animate"}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GbXR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HofU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  pufa: {
    home: 'https://kmt.laway.cn/pufa/km/home/',
    list: 'https://hnxcja.12348.laway.cn/postnews/list/?video=1',
    post: 'https://hnxcja.12348.laway.cn/postnews/view/?post_id='
  },
  list: '/pufa/api/post/list/?per_page=500&diagram_id=',
  post: '/pufa/post/?post_id=',
  // map: '/pufa/api/org/list/?per_page=500&org_type=',
  map: '/pufa/api/organization/?org_type=',
  xiaoxiang: {
    list: 'https://xiaoxiangs.laway.cn/question/list/',
    answer: 'https://xiaoxiangs.laway.cn/question/answer/'
  },
  case: 'https://hnxcja.12348.laway.cn/pufa/case/list/',
  case_post: 'https://hnxcja.12348.laway.cn/pufa/case/aview/?case_id=',
  lawfirm: 'https://hnxcja.12348.laway.cn/pufa/api/publiclawfirm/?code=',
  employee: 'https://hnxcja.12348.laway.cn/pufa/api/publiclawyer/?lawfirm=',
  jiandingoffice: 'https://hnxcja.12348.laway.cn/pufa/api/organization/?org_type=1&code=',
  jiandingemployee: 'https://hnxcja.12348.laway.cn/pufa/api/organizationemployee/?org_id=',
  heartbeat: 'https://hnxcja.12348.laway.cn/pufa/app/heartbeat/',
  caselibrary: 'https://hnxcja.12348.laway.cn/case/libary/',
  caselibrary_post: 'https://hnxcja.12348.laway.cn/case/libary/view/',

  hrpay: 'https://hrpay.laway.cn/api/speed-front', // 案例库查询
  doc: {
    types: 'https://hrpay.laway.cn/api/speed-front/doc/categories',
    list: 'https://hrpay.laway.cn/api/speed-front/doc/list', // 分类下列表
    detail: 'https://hrpay.laway.cn/api/speed-front/doc/detail?userId=yichanguser&htmlContent=&id=', // 详情
    hotlist: 'https://hrpay.laway.cn/api/speed-front/doc/hotDocs' // 热门文档列表
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__app__ = __webpack_require__("cpjA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lawStore__ = __webpack_require__("iTsH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common__ = __webpack_require__("zJ0b");





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {};
var mutations = {};
var getters = {};
var actions = {};
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  modules: {
    app: __WEBPACK_IMPORTED_MODULE_2__app__["a" /* default */],
    lawStore: __WEBPACK_IMPORTED_MODULE_3__lawStore__["a" /* default */],
    common: __WEBPACK_IMPORTED_MODULE_4__common__["a" /* default */]
  }
}));

/***/ }),

/***/ "IwMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = load;
/**
 * 路由载入组件
 * @param {*} component   组件名称
 * @param {*} paths       组件路径，默认page根目录
 */
function load(component) {
  var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // console.log(`@/page/${paths}/${component}.vue`)
  if (paths) {
    return function () {
      return __webpack_require__("msXg")("./" + paths + '/' + component + '.vue');
    };
  }
  return function () {
    return __webpack_require__("msXg")("./" + component + '.vue');
  };
}

/***/ }),

/***/ "L8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4db8a58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+UpC");
function injectStyle (ssrContext) {
  __webpack_require__("FW8Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4db8a58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_functions_common__ = __webpack_require__("Ri6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__functions_ajax__ = __webpack_require__("y6ZS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fun__ = __webpack_require__("+z4t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_lv_directory__ = __webpack_require__("4kIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_loading__ = __webpack_require__("e5RB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_design_icons_iconfont_material_icons_css__ = __webpack_require__("uTBe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_animate_css__ = __webpack_require__("oPmM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sass_index_scss__ = __webpack_require__("L8RT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__sass_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__sass_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__libs_config__ = __webpack_require__("6+u4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue2_datepicker__ = __webpack_require__("trBP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue2_datepicker_index_css__ = __webpack_require__("1QwG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue2_datepicker_locale_zh_cn__ = __webpack_require__("uwTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue2_datepicker_locale_zh_cn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue2_datepicker_locale_zh_cn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__datas_tool__ = __webpack_require__("gjCS");




var _this2 = this;

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$filePath = function (fileId) {
  return __WEBPACK_IMPORTED_MODULE_18__libs_config__["a" /* BASE_URL */] + '/file/download/' + fileId;
};






function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

__WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */].beforeEach(function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
    var get_code;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(to.path === '/register')) {
              _context.next = 3;
              break;
            }

            next();
            return _context.abrupt('return');

          case 3:
            if (getQueryVariable('license_key')) {
              localStorage.code = getQueryVariable('license_key');
            }
            get_code = localStorage.code || false;

            if (!get_code) {
              _context.next = 12;
              break;
            }

            if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].state.app.appInfo.appId) {
              _context.next = 9;
              break;
            }

            _context.next = 9;
            return __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('app/getAppInfoBySite');

          case 9:
            next();
            _context.next = 13;
            break;

          case 12:
            next({
              path: '/register'
            });

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this2);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14__components_loading__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__components_lv_directory__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_19_vue2_datepicker__["default"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_13_vue_infinite_scroll___default.a);
// Vue.prototype.$loading = Loading
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$scrollTo = __WEBPACK_IMPORTED_MODULE_9__src_functions_common__["b" /* scrollTo */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$get = __WEBPACK_IMPORTED_MODULE_10__functions_ajax__["b" /* get */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$post = __WEBPACK_IMPORTED_MODULE_10__functions_ajax__["c" /* post */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$request = __WEBPACK_IMPORTED_MODULE_10__functions_ajax__["d" /* requests */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$delay = __WEBPACK_IMPORTED_MODULE_11__fun__["d" /* delay */];
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].prototype.$formatTime = function (time) {
  return Object(__WEBPACK_IMPORTED_MODULE_22__datas_tool__["a" /* formatTime */])(time);
};

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */]({
  data: function data() {
    return {
      config: '',
      point: '',
      area: ''
    };
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var get_code, _this, getInfo, setData;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              get_code = localStorage.code || false;
              // const { result } = await get('https://hnxcja.12348.laway.cn/pufa/machine/current/version/')
              // if (!window.localStorage.version) {
              //   window.localStorage.version = result.version
              // }
              // if (parseInt(result.version) > parseInt(window.localStorage.version)) {
              //   if (NativeInterface && NativeInterface.clearAllCache) {// eslint-disable-line
              //     NativeInterface.clearAllCache() // eslint-disable-line
              //   }
              // }

              if (get_code) {
                _this = _this3;
                // 同步获取服务点信息

                getInfo = function getInfo() {
                  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                    var success = function success(_ref2) {
                      var info = _ref2.info,
                          status = _ref2.status,
                          msg = _ref2.msg;

                      if (!status) {
                        console.log('err:' + msg);
                        return;
                      }
                      resolve(info);
                    };
                    Object(__WEBPACK_IMPORTED_MODULE_10__functions_ajax__["a" /* asyncJquery */])('https://hnxcja.12348.laway.cn/pufa/machine/', 'POST', {
                      no: get_code
                    }, success);
                  });
                };
                // 同步获取站点信息并设置config


                setData = function setData(info) {
                  var success = function success(_ref3) {
                    var msg = _ref3.msg,
                        result = _ref3.result,
                        status = _ref3.status;

                    if (!status) {
                      console.log(msg);
                      return;
                    }
                    _this.point = info;
                    _this.config = result.info;
                    _this.area = result.area;
                  };
                  Object(__WEBPACK_IMPORTED_MODULE_10__functions_ajax__["a" /* asyncJquery */])('https://hnxcja.12348.laway.cn/get/website/info/', 'GET', {
                    code: info.code
                  }, success);
                };

                getInfo().then(function (info) {
                  setData(info);
                });
              }

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  },

  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */]
  }
});

/***/ }),

/***/ "Ri6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLangDate;
/* harmony export (immutable) */ __webpack_exports__["b"] = scrollTo;
function getLangDate() {
  var dateObj = new Date(); // 表示当前系统时间的Date对象
  var year = dateObj.getFullYear(); // 当前系统时间的完整年份值
  var month = dateObj.getMonth() + 1; // 当前系统时间的月份值
  var date = dateObj.getDate(); // 当前系统时间的月份中的日
  var day = dateObj.getDay(); // 当前系统时间中的星期值
  var weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  var week = weeks[day]; // 根据星期值，从数组中获取对应的星期字符串
  var hour = dateObj.getHours(); // 当前系统时间的小时值
  var minute = dateObj.getMinutes(); // 当前系统时间的分钟值
  var second = dateObj.getSeconds(); // 当前系统时间的秒钟值
  // 如果月、日、小时、分、秒的值小于10，在前面补0
  if (month < 10) {
    month = '0' + month;
  }
  if (date < 10) {
    date = '0' + date;
  }
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minute < 10) {
    minute = '0' + minute;
  }
  if (second < 10) {
    second = '0' + second;
  }
  var newDate = year + '年' + month + '月' + date + '日 ' + '<br>' + week + ' ' + hour + ':' + minute + ':' + second;

  return newDate;
}

function scrollTo() {
  var pos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  document.body.scrollTop = document.documentElement.scrollTop = pos;
}

/***/ }),

/***/ "S7Ac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    show: Boolean,
    ismask: Boolean,
    text: {
      type: String,
      default: '正在加载中...'
    }
  }
});

/***/ }),

/***/ "WSN5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAllAreas;
/* harmony export (immutable) */ __webpack_exports__["h"] = getLawlist;
/* harmony export (immutable) */ __webpack_exports__["j"] = getProfessionalList;
/* harmony export (immutable) */ __webpack_exports__["i"] = getLaworgs;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLawIndustrys;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLawForceLevelInfo;
/* harmony export (immutable) */ __webpack_exports__["f"] = getLawForceStatusInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCount;
/* unused harmony export getSearchLawArticle */
/* harmony export (immutable) */ __webpack_exports__["d"] = getLawDetail;
/* harmony export (immutable) */ __webpack_exports__["b"] = getBindPro;
/* harmony export (immutable) */ __webpack_exports__["l"] = recomPro;
/* harmony export (immutable) */ __webpack_exports__["k"] = getRecomLaws;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("aCoG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tool__ = __webpack_require__("1VXm");


var BASE_URL = 'https://hrpay.laway.cn/api/speed-front';
var APPID = __WEBPACK_IMPORTED_MODULE_1__libs_tool__["a" /* getAppId */]();
var axios = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */](BASE_URL, APPID);

function getAllAreas() {
  // 获取地区的接口
  return axios.request('get', '/area/getQuestionAllArea');
}

function getLawlist(params) {
  // 获取法律列表
  return axios.request('get', '/law/searchLaw', params);
}

function getProfessionalList() {
  // 专业列表
  return axios.request('get', '/professional/all', { type: 2 });
}

function getLaworgs() {
  // 获取发布机构列表
  return axios.request('get', '/law/lawOrgs');
}

function getLawIndustrys() {
  // 获取行业列表
  return axios.request('get', '/law/lawIndustrys');
}

function getLawForceLevelInfo() {
  // 获取效力等级信息
  return axios.request('get', '/law/lawForceLevelInfo');
}

function getLawForceStatusInfo() {
  // 获取效力状态信息
  return axios.request('get', '/law/lawForceStatusInfo');
}

function getCount() {
  // 获取数量
  return axios.request('get', '/law/count');
}

function getSearchLawArticle(params) {
  // 法条信息查询
  return axios.request('get', '/law/searchLawArticle', params);
}

function getLawDetail(id) {
  // 获取法律详情
  var params = {
    id: id
  };
  return axios.request('get', '/law/detail', params);
}

function getBindPro(level) {
  // 获取绑定的专业列表
  return axios.request('get', '/professional/listByForceLevel/' + level);
}

function recomPro(params) {
  // 推荐专业
  return axios.request('get', '/professional/list', params);
}

function getRecomLaws() {
  // 推荐法律
  return axios.request('get', '/law/getRecommendLaws');
}

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__law__ = __webpack_require__("ZFl5");


 // 法律法规
function load(component) {
  // '@' is aliased to src/page
  return function () {
    return __webpack_require__("msXg")("./" + component + '.vue');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: load('Home')
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_2__law__["a" /* default */]), [{
    path: '/register',
    name: 'Register',
    component: load('Register')
  }, {
    path: '/pufa',
    name: 'Pufa',
    component: load('Pufa')
  }, {
    path: '/yasf',
    name: 'PufaVideo',
    component: load('PufaVideo')
  }, {
    path: '/list/:diagramId',
    name: 'List',
    component: load('List')
  }, {
    path: '/listchildren/:diagramId',
    name: 'ListChildren',
    component: load('ListChildren')
  }, {
    path: '/post/:id',
    name: 'Post',
    component: load('Post')
  }, {
    path: '/service/:name',
    name: 'Service',
    component: load('Service')
  }, {
    path: '/map',
    name: 'MapList',
    component: load('MapList')
  }, {
    path: '/map/:org_type',
    name: 'Map',
    component: load('Map')
  }, {
    path: '/lvshi',
    name: 'ShequLvshi',
    component: load('ShequLvshi')
  }, {
    path: '/zixun',
    name: 'Advisory',
    component: load('Advisory')
  }, {
    path: '/child_advisory/:id',
    name: 'ChildAdvisory',
    component: load('ChildAdvisory')
  }, {
    path: '/zixun/:index',
    name: 'AdvisoryIn',
    component: load('AdvisoryIn')
  }, {
    path: '/wenshu',
    name: 'Wenshu',
    component: load('Wenshu')
  }, {
    path: '/law',
    name: 'Law',
    component: load('Law')
  }, {
    path: '/lawfirm',
    name: 'LawFirm',
    component: load('LawFirm')
  }, {
    path: '/case',
    name: 'Case',
    component: load('Case')
  }, {
    path: '/jianding',
    name: 'JianDing',
    component: load('JianDing')
  }, {
    path: '/test/:id',
    name: 'Test',
    component: load('Test')
  }, {
    path: '/bind_mobile',
    name: 'BindMobile',
    component: load('BindMobile')
  }, {
    path: '/reservation/0/1',
    name: 'Reservation',
    component: load('Reservation')
  }, {
    path: '/arc',
    name: 'Arc',
    component: load('Arc')
  }, {
    path: '/gzpost',
    name: 'GzPost',
    component: load('GzPost')
  },
  // 测试
  {
    path: '/jd',
    name: 'JD',
    component: load('JD')
  }, {
    path: '/jdlist',
    name: 'JDList',
    component: load('JDList')
  }, {
    path: '/jdpost',
    name: 'JDPost',
    component: load('JDPost')
  }, {
    path: '/caselibrary',
    name: 'CaseLibrary',
    component: load('CaseLibrary')
  }, {
    path: '/caselibrary/:case_id',
    name: 'CaseLibraryPost',
    component: load('CaseLibraryPost')
  }, {
    path: '/suggest',
    name: 'Suggest',
    component: load('Suggest')
  },
  // 计算器
  {
    path: '/calculator',
    name: 'Calculator',
    component: load('Calculator')
  },
  // 民法典
  {
    path: '/minfadian',
    name: 'Minfadian',
    component: load('Minfadian')
  }])
}));

/***/ }),

/***/ "ZFl5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__load__ = __webpack_require__("IwMe");


/* harmony default export */ __webpack_exports__["a"] = ([
// 法规
{
  path: '/law',
  name: 'Law',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__load__["a" /* default */])('Law', 'law')
}, {
  path: '/lawlist',
  name: 'LawList',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__load__["a" /* default */])('LawList', 'law')
}, {
  path: '/lawsearch',
  name: 'LawSearch',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__load__["a" /* default */])('LawSearch', 'law')
}, {
  path: '/lawdetail/:id',
  name: 'LawDetail',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__load__["a" /* default */])('LawDetail', 'law')
}, {
  path: '/FaLvList',
  name: 'FaLvList',
  component: Object(__WEBPACK_IMPORTED_MODULE_0__load__["a" /* default */])('FaLvList', 'law')
}]);

/***/ }),

/***/ "aCoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);






var Fetch = function () {
  function Fetch(baseUrl, appId) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Fetch);

    this.setInterceptors = function (instance) {
      instance.interceptors.request.use(function (config) {
        if (config.method === 'get') {
          config.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config.params, {
            appId: _this.appId
          });
        }
        if (config.method === 'post') {
          config.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config.params, {
            appId: _this.appId
          });
        }
        return config;
      }, function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });

      instance.interceptors.response.use(function (response) {
        return response.data;
      }, function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    };

    this.appId = appId || null;
    this.BASE_URL = baseUrl;
    this.timeout = 60 * 1000;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Fetch, [{
    key: 'request',
    value: function request(method, url, params, data) {
      var instance = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create();
      var config = {
        method: method,
        url: url,
        params: params,
        data: data,
        baseURL: this.BASE_URL,
        timeout: this.timeout
      };
      this.setInterceptors(instance);
      return instance(config);
    }
  }]);

  return Fetch;
}();

/* harmony default export */ __webpack_exports__["a"] = (Fetch);

/***/ }),

/***/ "cpjA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_base64__ = __webpack_require__("xrTZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_app__ = __webpack_require__("mof7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_tool__ = __webpack_require__("1VXm");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    appInfo: {}
  },
  mutations: {
    setAppInfo: function setAppInfo(state, data) {
      state.appInfo = data;
    }
  },
  actions: {
    getAppInfoBySite: function getAppInfoBySite(_ref) {
      var commit = _ref.commit;

      var site = 'https://hnxcja.ai.lvpin100.com';
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_2__api_app__["a" /* getAppInfoBySite */](__WEBPACK_IMPORTED_MODULE_1_js_base64__["Base64"].encode(site)).then(function (res) {
          if (res.response.success && res.data) {
            commit('setAppInfo', res.data);
            __WEBPACK_IMPORTED_MODULE_3__libs_tool__["c" /* setAppId */](res.data.appId);
            resolve({ success: true });
          } else {
            console.log('[ got an error response ]', res.response.msg);
            resolve({ success: false });
          }
        }).catch(function (error) {
          console.log('[ catch an error ]', error);
          reject(error);
        });
      });
    }
  },
  getters: {
    getAppInfo: function getAppInfo(state) {
      return state.appInfo;
    }
  }
});

/***/ }),

/***/ "e5RB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loading_vue__ = __webpack_require__("hGVa");


var $vm = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  install: function install(Vue, options) {
    if (!$vm) {
      var LoadingPlugin = Vue.extend(__WEBPACK_IMPORTED_MODULE_0__Loading_vue__["a" /* default */]);
      $vm = new LoadingPlugin({
        el: document.createElement('div')
      });
      document.body.appendChild($vm.$el);
    }

    $vm.show = false;

    var loading = {
      show: function show(txt) {
        var ismask = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        $vm.show = true;
        $vm.ismask = ismask;
        if (txt && txt.trim()) {
          $vm.text = txt;
        }
      },
      hide: function hide() {
        $vm.show = false;
      }
    };

    if (!Vue.$loading) {
      Vue.$loading = loading;
    }

    Vue.mixin({
      created: function created() {
        this.$loading = Vue.$loading;
      },
      mounted: function mounted() {
        this.$loading = Vue.$loading;
      }
    });
  }
});

/***/ }),

/***/ "gjCS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = listToTree;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatTime;
function _sortFunc(a, b) {
  return a.sort - b.sort;
}

function listToTree(srcList, destList) {
  var sortFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _sortFunc;
  var repare = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!destList) {
    destList = [];
  } else {
    destList.splice(0, destList.length);
  }
  if (!srcList) return destList;
  var nodeData = {};
  srcList.forEach(function (item) {
    if (item.name) {
      item.label = item.name;
      item.value = item.id;
    }
    item.children = [];
    nodeData[item.id] = item;
  });
  srcList.forEach(function (item) {
    if (item.parentId) {
      var parent = nodeData[item.parentId];
      if (parent) {
        parent.children.push(item);
        parent.children.sort(sortFunc);
        return;
      }
      if (!parent && repare) {
        item = {};
        return;
      }
    }
    destList.push(item);
  });
  destList.sort(sortFunc);
  return destList;
}
function formatTime(timestamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd HH:mm';

  var formatNum = function formatNum(num) {
    return String(num).padStart(2, '0');
  };
  var date = new Date(timestamp);
  return format.replace(/yyyy/g, date.getFullYear()).replace(/MM/g, formatNum(date.getMonth() + 1)).replace(/dd/g, formatNum(date.getDate())).replace(/HH/g, formatNum(date.getHours())).replace(/mm/g, formatNum(date.getMinutes())).replace(/ss/g, formatNum(date.getSeconds())).replace(/SSS/g, formatNum(date.getMilliseconds()));
}

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_tool__ = __webpack_require__("1VXm");







var Fetch = function () {
  function Fetch(baseUrl, appId) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Fetch);

    this.setInterceptors = function (instance) {
      instance.interceptors.request.use(function (config) {
        if (config.method === 'get') {
          config.params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config.params, {
            appId: _this.appId || __WEBPACK_IMPORTED_MODULE_5__libs_tool__["a" /* getAppId */]()
          });
        }
        if (config.method === 'post') {
          config.data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, config.params, {
            appId: _this.appId || __WEBPACK_IMPORTED_MODULE_5__libs_tool__["a" /* getAppId */]()
          });
        }
        return config;
      }, function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });

      instance.interceptors.response.use(function (response) {
        return response.data;
      }, function (err) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
      });
    };

    this.appId = appId || __WEBPACK_IMPORTED_MODULE_5__libs_tool__["a" /* getAppId */]() || null;
    this.BASE_URL = baseUrl;
    this.timeout = 60 * 1000;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Fetch, [{
    key: 'request',
    value: function request(method, url, params, data) {
      var instance = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create();
      var config = {
        method: method,
        url: url,
        params: params,
        data: data,
        baseURL: this.BASE_URL,
        timeout: this.timeout
      };
      this.setInterceptors(instance);
      return instance(config);
    }
  }]);

  return Fetch;
}();

/* harmony default export */ __webpack_exports__["a"] = (Fetch);

/***/ }),

/***/ "hGVa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("S7Ac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc3fe52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("FyIo");
function injectStyle (ssrContext) {
  __webpack_require__("GbXR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dc3fe52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dc3fe52_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iTsH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datas_law__ = __webpack_require__("WSN5");

// import * as tool from '../datas/js/tool'

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    professional: [], // 专业列表
    orgs: [], // 发布机构列表
    industrys: [], // 行业列表
    forceLevel: [], // 效力等级
    forceStatus: [] // 效力状态
  },
  mutations: {
    setProfessional: function setProfessional(state, data) {
      state.professional = data || [];
    },
    setOrgs: function setOrgs(state, data) {
      var list = data || [];
      state.orgs = list;
    },
    setIndustrys: function setIndustrys(state, data) {
      var list = data || [];
      state.industrys = list;
    },
    setforceLevel: function setforceLevel(state, data) {
      var list = data || [];
      state.forceLevel = list;
    },
    setforceStatus: function setforceStatus(state, data) {
      var list = data || [];
      state.forceStatus = list;
    }
  },
  actions: {
    getProfessionalList: function getProfessionalList(_ref) {
      var commit = _ref.commit;

      return __WEBPACK_IMPORTED_MODULE_0__datas_law__["j" /* getProfessionalList */]().then(function (res) {
        if (res.response.success) {
          commit('setProfessional', res.data);
        } else {
          console.log('[ got an error when getProfessionalList() in store ]', res.response.msg);
        }
      }).catch(function (error) {
        console.log('[ got an error when getProfessionalList() in store ]', error);
      });
    },
    getOrgs: function getOrgs(_ref2) {
      var commit = _ref2.commit;

      return __WEBPACK_IMPORTED_MODULE_0__datas_law__["i" /* getLaworgs */]().then(function (res) {
        if (res.response.success) {
          commit('setOrgs', res.data);
        } else {
          console.log('[ got an error when getOrgs() in store ]', res.response.msg);
        }
      }).catch(function (error) {
        console.log('[ got an error when getOrgs() in store ]', error);
      });
    },
    getIndustrys: function getIndustrys(_ref3) {
      var commit = _ref3.commit;

      return __WEBPACK_IMPORTED_MODULE_0__datas_law__["g" /* getLawIndustrys */]().then(function (res) {
        if (res.response.success) {
          commit('setIndustrys', res.data);
        } else {
          console.log('[ got an error when getIndustrys() in store ]', res.response.msg);
        }
      }).catch(function (error) {
        console.log('[ got an error when getIndustrys() in store ]', error);
      });
    },
    getForceLevel: function getForceLevel(_ref4) {
      var commit = _ref4.commit;

      return __WEBPACK_IMPORTED_MODULE_0__datas_law__["e" /* getLawForceLevelInfo */]().then(function (res) {
        if (res.response.msg) {
          commit('setforceLevel', res.data);
        } else {
          console.log('[ got an error when getForceLevel() in store ]', res.response.msg);
        }
      }).catch(function (error) {
        console.log('[ got an error when getForceLevel() in store ]', error);
      });
    },
    getForceStatus: function getForceStatus(_ref5) {
      var commit = _ref5.commit;

      return __WEBPACK_IMPORTED_MODULE_0__datas_law__["f" /* getLawForceStatusInfo */]().then(function (res) {
        if (res.response.success) {
          commit('setforceStatus', res.data);
        } else {
          console.log('[ got an error when getForceStatus() in store ]', res.response.msg);
        }
      }).catch(function (error) {
        console.log('[ got an error when getForceStatus() in store ]', error);
      });
    }
  },
  getters: {
    professionalList: function professionalList(state) {
      return state.professional;
    },
    orgs: function orgs(state) {
      return state.orgs;
    },
    industrys: function industrys(state) {
      return state.industrys;
    },
    forceLevel: function forceLevel(state) {
      return state.forceLevel;
    },
    forceStatus: function forceStatus(state) {
      return state.forceStatus;
    }
  }
});

/***/ }),

/***/ "mof7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getAppInfoByAppId */
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppInfoBySite;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAppList;
/* harmony export (immutable) */ __webpack_exports__["c"] = getChildren;
/* unused harmony export getCount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_config__ = __webpack_require__("6+u4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_tool__ = __webpack_require__("1VXm");



var appId = __WEBPACK_IMPORTED_MODULE_2__libs_tool__["a" /* getAppId */]() || null;
var axios = new __WEBPACK_IMPORTED_MODULE_0__index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1__libs_config__["a" /* BASE_URL */], appId);

function getAppInfoByAppId() {
  // 根据appId获取app详情
  return axios.request('get', '/app/detailByAppId/' + appId);
}

function getAppInfoBySite(site) {
  // 根据网址获取app信息
  return axios.request('get', '/app/detailBySite/' + site);
}

function getAppList(params) {
  // 获取项目列表
  return axios.request('get', '/app/projects/' + params.appId, params);
}

function getChildren(_ref) {
  var id = _ref.id,
      m = _ref.m;

  // 获取子项目
  return axios.request('get', '/app/children/' + id, m);
}

function getCount() {
  // 获取已出具的法律意见书数量
  return axios.request('get', '/question/getCount/' + appId);
}

/***/ }),

/***/ "msXg":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Advisory.vue": [
		"kTN+",
		17
	],
	"./AdvisoryIn.vue": [
		"a4Wl",
		10
	],
	"./Arc.vue": [
		"dGjo",
		7
	],
	"./BindMobile.vue": [
		"92TF",
		6
	],
	"./Calculator.vue": [
		"quTU",
		38
	],
	"./Case.vue": [
		"fVtH",
		37
	],
	"./CaseLibrary.vue": [
		"iTqL",
		36
	],
	"./CaseLibraryPost.vue": [
		"d1XS",
		35
	],
	"./ChildAdvisory.vue": [
		"Hg3B",
		16
	],
	"./FMobileDataCollect.vue": [
		"51E5",
		25
	],
	"./FMobileInputWidget.vue": [
		"5APl",
		40
	],
	"./GzPost.vue": [
		"O7Ri",
		34
	],
	"./Home.vue": [
		"ZHiF",
		39
	],
	"./JD.vue": [
		"mZxK",
		26
	],
	"./JDList.vue": [
		"+sJf",
		9
	],
	"./JDList_test.vue": [
		"PG6W",
		33
	],
	"./JDPost_test.vue": [
		"nCpi",
		8
	],
	"./JianDing.vue": [
		"/FY/",
		12
	],
	"./LawFirm.vue": [
		"jjGA",
		2
	],
	"./List.vue": [
		"7ouc",
		23
	],
	"./ListChildren.vue": [
		"7XD6",
		22
	],
	"./Map.vue": [
		"w4U6",
		5
	],
	"./MapList.vue": [
		"W0du",
		24
	],
	"./Minfadian.vue": [
		"Z8Xy",
		15
	],
	"./Post.vue": [
		"Z5qW",
		21
	],
	"./Pufa.vue": [
		"Dsua",
		20
	],
	"./PufaDetail.vue": [
		"1Boo",
		32
	],
	"./PufaVideo.vue": [
		"yRhP",
		14
	],
	"./Register.vue": [
		"9w24",
		18
	],
	"./Reservation.vue": [
		"IGkd",
		4
	],
	"./Service.vue": [
		"ywn1",
		19
	],
	"./ShequLvshi.vue": [
		"9F3b",
		3
	],
	"./Suggest.vue": [
		"1o9U",
		13
	],
	"./Test.vue": [
		"1PPF",
		11
	],
	"./Wenshu.vue": [
		"xEPf",
		31
	],
	"./Yuanzhu.vue": [
		"RRRm",
		30
	],
	"./law/FaLvList.vue": [
		"H5oP",
		29
	],
	"./law/Law.vue": [
		"h3TD",
		28
	],
	"./law/LawDetail.vue": [
		"I/UG",
		1
	],
	"./law/LawList.vue": [
		"Jh6/",
		27
	],
	"./law/LawSearch.vue": [
		"JZPe",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "msXg";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "nCtB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__("DlMc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);



var ATTR_NAME = 'navigation_anchor_by_tortormore_yes';

function createLinkElement(dom) {
  var id = 'id' + Object(__WEBPACK_IMPORTED_MODULE_1_uuid__["v4"])().replace(/-/g, '');
  var element = document.createElement('a');
  element.setAttribute('id', id);
  element.setAttribute(ATTR_NAME, true);
  dom.parentNode.insertBefore(element, dom);
  return id;
}

function generateNavTree(dom, selectors, exceptSelector) {
  clearLinkElement(dom);
  var list = [];
  if (exceptSelector) {
    var exceptList = dom.querySelectorAll(exceptSelector);
    exceptList.forEach(function (element) {
      element.__nav_except = true;
    });
  }

  var _loop = function _loop(idx) {
    var elementList = dom.querySelectorAll(selectors[idx]);
    elementList.forEach(function (element) {
      if (element.__nav_except || element.offsetParent === null) return;
      element.__nav_level = idx;
    });
  };

  for (var idx in selectors) {
    _loop(idx);
  }
  var selector = selectors.join(',');
  var domList = dom.querySelectorAll(selector);
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(domList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var element = _step.value;

      if (!element.__nav_level) {
        delete element.__nav_except;
        continue;
      }
      var pushList = list;
      while (element.__nav_level > 0) {
        pushList = pushList.length ? pushList[pushList.length - 1].children : null;
        if (!pushList) break;
        element.__nav_level--;
      }
      var data = {
        title: element.textContent,
        children: [],
        id: createLinkElement(element)
      };
      pushList && pushList.push(data);
      delete element.__nav_level;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  dom.__mutationObverser && dom.__mutationObverser.observe(dom, { subtree: true, childList: true });
  return list;
}

function clearLinkElement(dom) {
  dom = dom || document;
  var domList = dom.querySelectorAll('a[' + ATTR_NAME + ']');
  for (var idx = domList.length - 1; idx > -1; idx--) {
    var element = domList[idx];
    element.parentNode.removeChild(element);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vNode) {
    el.__navigationGenerateFunction = function () {
      var selectors = binding.value.selectors || ['h1', 'h2'];
      var exceptSelector = binding.value.exceptSelector;
      vNode.context.$nextTick(function () {
        // 停止观察
        el.__mutationObverser && el.__mutationObverser.disconnect();
        // 找到第一个生效的选择器，开始有效选择器部分
        var idx = selectors.findIndex(function (selector) {
          var list = el.querySelectorAll(selector);
          return !!list.length;
        });
        selectors = idx < 0 ? selectors : selectors.slice(idx);

        var list = generateNavTree(el, selectors, exceptSelector);
        binding.value.callback(list);
        // 重新观察
        el.__mutationObverser && el.__mutationObverser.observe(el, { subtree: true, childList: true });
      });
    };
    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    el.__mutationObverser = new MutationObserver(function () {
      el.__navigationGenerateFunction && el.__navigationGenerateFunction();
    });
    el.__mutationObverser.observe(el, { subtree: true, childList: true });
    el.__navigationGenerateFunction && el.__navigationGenerateFunction();
  },
  unbind: function unbind(el, binding, vNode) {
    clearLinkElement();
    if (el.__navigationGenerateFunction) {
      delete el.__navigationGenerateFunction;
    }
    if (el.__mutationObverser) {
      el.__mutationObverser.takeRecords();
      el.__mutationObverser.disconnect();
    }
  }
});

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uTBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__datas_api_js__ = __webpack_require__("HofU");
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  mounted: function mounted() {
    var getcode = localStorage.code || false;
    var _this = this;
    setInterval(function () {
      // heartbeat 心跳包
      if (getcode) {
        console.log('心跳包');
        try {
          _this.$get(__WEBPACK_IMPORTED_MODULE_0__datas_api_js__["a" /* default */].heartbeat);
        } catch (e) {
          console.log(e);
        }
      }
    }, 60000); // 发送心跳包
  }
});

/***/ }),

/***/ "y6ZS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return requests; });
/* harmony export (immutable) */ __webpack_exports__["b"] = get;
/* harmony export (immutable) */ __webpack_exports__["c"] = post;
/* harmony export (immutable) */ __webpack_exports__["a"] = asyncJquery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);



var DevBaseUrl = 'https://hnxcja.12348.laway.cn/';
// const DevBaseUrl = 'http://localhost:8888'
var ProdBashUrl = 'https://hnxcja.12348.laway.cn/';

var config = {
  baseURL:  false ? DevBaseUrl : ProdBashUrl, // 配置API接口地址
  headers: {
    Authorization: localStorage.code ? 'ZD ' + localStorage.code : ''
    // timeout: 15000
  } };

__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.code ? 'ZD ' + localStorage.code : '';
  return config;
});

var request = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(config);
var requests = request;

function get(url, _this) {
  var loader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  // url = url.includes('http://') ? url : api + url
  if (_this) {
    _this.$loading.show(loader);
  }
  return request.get(url).then(function (res) {
    if (_this) {
      _this.$loading.hide();
    }
    if (res.status !== 200) {
      throw new Error(res.url + ' ' + res.status + ' ' + res.statusText);
    }
    return res.data;
  }).catch(function (err) {
    if (_this) {
      _this.$loading.hide();
    }
    throw err;
  });
}

function post(url, query, _this) {
  var loader = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  if (_this) {
    _this.$loading.show(loader);
  }
  return request.post(url, query).then(function (res) {
    if (_this) {
      _this.$loading.hide();
    }
    if (res.status !== 200) {
      throw new Error(res.url + ' ' + res.status + ' ' + res.statusText);
    }
    return res.data;
  }).catch(function (err) {
    if (_this) {
      _this.$loading.hide();
    }
    throw err;
  });
}

function asyncJquery(url, type, data) {
  var success = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (data, textStatus, jqXHR) {
    console.log(data);
  };
  var async = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var timeout = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 3000;
  var error = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function (xhr, textStatus) {
    console.log(textStatus);
  };

  __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
    url: url,
    type: type, // GET
    async: async, // 或false,是否异步
    data: data,
    timeout: timeout, // 超时时间
    dataType: 'json', // 返回的数据格式：
    success: success,
    error: error
  });
}

/***/ }),

/***/ "zJ0b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__datas_law__ = __webpack_require__("WSN5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__datas_tool__ = __webpack_require__("gjCS");




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: {
    area: {
      data: {},
      tree: [],
      loaded: false
    }
  },
  actions: {
    getAllArea: function getAllArea(_ref) {
      var state = _ref.state,
          commit = _ref.commit;
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!data.force && state.area.loaded) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          resolve(true);
        });
      }
      return Object(__WEBPACK_IMPORTED_MODULE_1__datas_law__["a" /* getAllAreas */])().then(function (res) {
        if (!res.response.success) return false;
        commit('updateAreaData', res.data || []);
        return true;
      });
    }
  },
  mutations: {
    updateAreaData: function updateAreaData(state, areaList) {
      var data = {};
      areaList.forEach(function (area) {
        data[area.id] = area;
      });
      state.area.tree = __WEBPACK_IMPORTED_MODULE_2__datas_tool__["b" /* listToTree */](areaList);
      state.area.data = data;
    }
  },
  getters: {
    areaData: function areaData(state) {
      return state.area.data;
    },
    areaTree: function areaTree(state) {
      return state.area.tree;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.829eca40f57aeacc983a.js